var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", { staticClass: "mt-2" }, [_vm._v("Logs")]),
      _c("top-table", {
        attrs: {
          showLoadAllData: true,
          tabFilters: _vm.options.tabFilters,
          columns: [
            "userId",
            "category",
            "notes",
            "changes",
            "parent",
            "parentCollection",
            "createdAt",
            "ip",
            "service",
          ],
          headings: _vm.options.headings,
          sortable: [
            "category",
            "notes",
            "parentCollection",
            "ip",
            "createdAt",
          ],
          "order-by": { column: "createdAt", ascending: 0 },
          searchColumns: ["notes"],
          url: "/logs",
          "request-function": _vm.onBeforeReq,
          overlap: true,
          hasClearFilters: true,
        },
        scopedSlots: _vm._u([
          {
            key: "customAfterFilter",
            fn: function (props) {
              return _c("span", {}, [
                _c("i", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true },
                    },
                  ],
                  staticClass: "fas fa-question-circle ml-2",
                  attrs: { title: "Search by notes, mongo hash Id" },
                }),
              ])
            },
          },
          {
            key: "service",
            fn: function (props) {
              return [
                _vm._v("\n      " + _vm._s(props.row.env || "") + "\n    "),
              ]
            },
          },
          {
            key: "userId",
            fn: function (props) {
              return [
                props.row.isSystem
                  ? _c("b-avatar", {
                      attrs: {
                        variant: "warning",
                        text: `MP`,
                        title: `MPower`,
                        src: "/img/mpower_mark.svg",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            [
                              props.row.userId && props.row.userId.firstName,
                              props.row.userId && props.row.userId.lastName,
                            ]
                              .filter((e) => e)
                              .join(" ")
                          ) +
                          "\n      "
                      ),
                    ]),
              ]
            },
          },
          {
            key: "category",
            fn: function (props) {
              return [_c("LogView", { attrs: { log: props.row } })]
            },
          },
          {
            key: "notes",
            fn: function (props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      props.row.category === "PRIVATE_DATA_RESPONSE"
                        ? _vm.groupResponseUrls(props.row)
                        : props.row.notes
                    ) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "parentCollection",
            fn: function (props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      (props.row.orderId && "orders") ||
                        props.row.parentCollection ||
                        "-"
                    ) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "parent",
            fn: function (props) {
              return [
                props.row.parent
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: `/${props.row.parentCollection}/${props.row.parent._id}`,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            [
                              props.row.parent.firstName,
                              props.row.parent.lastName,
                            ]
                              .filter((e) => e)
                              .join(" ")
                          )
                        ),
                      ]
                    )
                  : props.row.orderId
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: `/admin/orders/${props.row.orderId.orderId}`,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            props.row.orderId &&
                              [props.row.orderId.orderId, props.row.purchaseId]
                                .filter((e) => e)
                                .join(", ")
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "createdAt",
            fn: function (props) {
              return [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("dateWithTime")(props.row.createdAt))),
                ]),
              ]
            },
          },
          {
            key: "changes",
            fn: function (props) {
              return [
                props.row.changes.length
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-overflow": "ellipsis",
                          overflow: "hidden",
                        },
                        attrs: {
                          title: props.row.changes
                            .map((e) => `${e.attribute}->${e.newValue || ""}`)
                            .join(", "),
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              props.row.changes
                                .map(
                                  (e) =>
                                    `${e.attribute}-${e.oldValue || ""}->${
                                      e.newValue || ""
                                    }`
                                )
                                .join(", ")
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                props.row.details
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-overflow": "ellipsis",
                          overflow: "hidden",
                        },
                        attrs: { title: props.row.details },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(props.row.details))]),
                        _vm.detailsBody(props.row.details)
                          ? _c("PreviewRequest", {
                              attrs: {
                                details: _vm.detailsBody(props.row.details),
                                fullScreen: true,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-lg btn-link p-0",
                                            on: { click: props.onShowDetails },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-info-circle",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                props.row.body?.length
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-overflow": "ellipsis",
                          overflow: "hidden",
                        },
                        attrs: { title: props.row.body },
                      },
                      [
                        _c("span", [_vm._v(" " + _vm._s(props.row.body))]),
                        _c("PreviewRequest", {
                          attrs: {
                            details: _vm.detailsBody(props.row.body),
                            fullScreen: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-lg btn-link p-0",
                                        on: { click: props.onShowDetails },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "far fa-info-circle",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }